import {
    COM_PURCHASE_ORDER,
    COM_PURCHASE_ORDER_SUCCESS,
    COM_PURCHASE_ORDER_ERROR,
    COM_SUPPLIER,
    COM_SUPPLIER_SUCCESS,
    COM_SUPPLIER_ERROR,
    COM_CATEGORY,
    COM_CATEGORY_SUCCESS,
    COM_CATEGORY_ERROR,
    COM_USER_ASSIGNED,
    COM_USER_ASSIGNED_SUCCESS,
    COM_USER_ASSIGNED_ERROR,
    COM_STATUS,
    COM_STATUS_SUCCESS,
    COM_STATUS_ERROR,
    COM_USER_FOR_ASSIGN,
    COM_USER_FOR_ASSIGN_SUCCESS,
    COM_USER_FOR_ASSIGN_ERROR,
    COMMUNICATION_LIST,
    COMMUNICATION_LIST_SUCCESS,
    COMMUNICATION_LIST_ERROR,
    COMMUNICATION_SEARCH_CHANGE,
    COMMUNICATION_PAGE_SET,
    COMMUNICATION_EDIT_MODAL_SET,
    COMMUNICATION_EDIT_SET_DATA,
    COMMUNICATION_EDIT_CHANGE_SET,
    COMMUNICATION_EDIT,
    COMMUNICATION_EDIT_SUCCESS,
    COMMUNICATION_EDIT_ERROR,
    COMMUNICATION_ANSWER_MODAL_SET,
    COMMUNICATION_ANSWER_SET_DATA,
    COMMUNICATION_ANSWER_CHANGE_SET,
    COMMUNICATION_ANSWER,
    COMMUNICATION_ANSWER_SUCCESS,
    COMMUNICATION_ANSWER_ERROR,
    COMMUNICATION_SEE_MODAL_SET,
    COMMUNICATION_SEE_SET_DATA,
    COMMUNICATION_UPLOAD_SET,
    COMMUNICATION_UPLOAD_SET_SUCCESS,
    COMMUNICATION_UPLOAD_SET_ERROR,
    COMMUNICATION_UPLOAD_RESET,
} from "../actions";

const INIT_STATE = {
    loading: false,
    list: {
        page: {
            current: 1,
            rows: 10
        }
    },
    purchaseorder: {
        loading: false,
        data: []
    },
    supplier: {
        loading: false,
        data: []
    },
    category: {
        loading: false,
        data: []
    },
    userassigned: {
        loading: false,
        data: []
    },
    status: {
        loading: false,
        data: []
    },
    userforassign: {
        loading: false,
        data: []
    },
    detail: {
        data: []
    },
    edit: {
        data: [],
        modal: false,
        loading: false,
        message: '',
        url: '',
        type: ''
    },
    detailanswer: {
        data: []
    },
    answer: {
        data: [],
        modal: false,
        loading: false,
        message: '',
        url: '',
        type: ''
    },
    detailsee: {
        data: []
    },
    see: {
        data: [],
        modal: false,
        loading: false,
        message: '',
        url: '',
        type: ''
    },
    file: [],
    error: false,
    search: {
        modal: false,
        init: true,
        data: {
            purchaseorder: '',
            supplier: '',
            userassigned: '',
            category: '',
            status: '',
            unassigned: '',
            attend: '',
            alert: '',
            urgent:''
        },
        value: {
            purchaseorder: '',
            supplier: '',
            userassigned: '',
            category: '',
            status: '',
            unassigned: '',
            attend: '',
            alert: '',
            urgent: ''
        }
    }
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case COM_PURCHASE_ORDER:
            return {
                ...state,
                loading: true,
                purchaseorder: {
                    ...state.purchaseorder
                }
            }
        case COM_PURCHASE_ORDER_SUCCESS:
            return {
                ...state,
                loading: false,
                purchaseorder: {
                    ...state.purchaseorder,
                    ...action.payload
                }
            }
        case COM_PURCHASE_ORDER_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        case COM_SUPPLIER:
            return {
                ...state,
                loading: true,
                supplier: {
                    ...state.supplier
                }
            }
        case COM_SUPPLIER_SUCCESS:
            return {
                ...state,
                loading: false,
                supplier: {
                    ...state.supplier,
                    ...action.payload
                }
            }
        case COM_SUPPLIER_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        case COM_CATEGORY:
            return {
                ...state,
                loading: true,
                category: {
                    ...state.category
                }
            }
        case COM_CATEGORY_SUCCESS:
            return {
                ...state,
                loading: false,
                category: {
                    ...state.category,
                    ...action.payload
                }
            }
        case COM_CATEGORY_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        case COM_USER_ASSIGNED:
            return {
                ...state,
                loading: true,
                userassigned: {
                    ...state.userassigned
                }
            }
        case  COM_USER_ASSIGNED_SUCCESS:
            return {
                ...state,
                loading: false,
                userassigned: {
                    ...state.userassigned,
                    ...action.payload
                }
            }
        case  COM_USER_ASSIGNED_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        case COM_STATUS:
            return {
                ...state,
                loading: true,
                status: {
                    ...state.status
                }
            }
        case COM_STATUS_SUCCESS:
            return {
                ...state,
                loading: false,
                status: {
                    ...state.status,
                    ...action.payload
                }
            }
        case COM_STATUS_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        case COM_USER_FOR_ASSIGN:
            return {
                ...state,
                loading: true,
                userforassign: {
                    ...state.userforassign
                }
            }
        case COM_USER_FOR_ASSIGN_SUCCESS:
            return {
                ...state,
                loading: false,
                userforassign: {
                    ...state.userforassign,
                    ...action.payload
                }
            }
        case COM_USER_FOR_ASSIGN_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }

        case COMMUNICATION_LIST:
            return {
                ...state,
                loading: true,
                list: {
                    ...state.list
                }
            }
        case COMMUNICATION_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                list: {
                    ...state.list,
                    ...action.payload
                }
            }
        case COMMUNICATION_LIST_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }

        case COMMUNICATION_PAGE_SET:
            return {
                ...state,
                list: {
                    ...state.list,
                    page: {
                        ...state.list.page,
                        ...action.payload,
                    }
                }
            }
        case COMMUNICATION_SEARCH_CHANGE:
            return {
                ...state,
                search: {
                    ...state.search,
                    data: action.payload,
                }
            }
        case COMMUNICATION_EDIT_MODAL_SET:
            return {
                ...state,
                edit: {
                    ...state.edit,
                    modal: action.payload
                }
            }
        case COMMUNICATION_EDIT_SET_DATA:
            return {
                ...state,
                detail: {
                    ...state.detail,
                    ...action.payload
                }
            }
        case COMMUNICATION_EDIT_CHANGE_SET:
            return {
                ...state,
                edit: {
                    ...state.edit,
                    data: {
                        ...state.edit.data,
                        ...action.payload
                    }
                }
            }
        case COMMUNICATION_EDIT:
            return {
                ...state,
                edit: {
                    ...state.edit,
                    loading: false
                }
            }
        case COMMUNICATION_EDIT_SUCCESS:
            return {
                ...state,
                edit: {
                    ...state.edit,
                    modal: false,
                    loading: false,
                    url: action.payload.url,
                    type: action.payload.type,
                    message: action.payload.message
                },
                list: {
                    ...state.list,
                    ...action.payload
                }
            }
        case COMMUNICATION_EDIT_ERROR:
            return {
                ...state,
                edit: {
                    ...state.edit,
                    loading: false,
                    type: action.payload.type,
                    message: action.payload.message
                }
            }
        case COMMUNICATION_ANSWER_MODAL_SET:
            return {
                ...state,
                answer: {
                    ...state.answer,
                    modal: action.payload
                }
            }
        case COMMUNICATION_ANSWER_SET_DATA:
            return {
                ...state,
                detailanswer: {
                    ...state.detailanswer,
                    ...action.payload
                }
            }
        case COMMUNICATION_ANSWER_CHANGE_SET:
            return {
                ...state,
                answer: {
                    ...state.answer,
                    data: {
                        ...state.answer.data,
                        ...action.payload
                    }
                }
            }
        case COMMUNICATION_ANSWER:
            return {
                ...state,
                answer: {
                    ...state.answer,
                    loading: false
                }
            }
        case COMMUNICATION_ANSWER_SUCCESS:
            return {
                ...state,
                answer: {
                    ...state.answer,
                    modal: false,
                    loading: false,
                    url: action.payload.url,
                    type: action.payload.type,
                    message: action.payload.message
                },
                list: {
                    ...state.list,
                    ...action.payload
                }
            }
        case COMMUNICATION_ANSWER_ERROR:
            return {
                ...state,
                answer: {
                    ...state.answer,
                    loading: false,
                    type: action.payload.type,
                    message: action.payload.message
                }
            }
        case COMMUNICATION_SEE_MODAL_SET:
            return {
                ...state,
                see: {
                    ...state.see,
                    modal: action.payload
                }
            }
        case COMMUNICATION_SEE_SET_DATA:
            return {
                ...state,
                detailsee: {
                    ...state.detailsee,
                    ...action.payload
                }
            }
        case COMMUNICATION_UPLOAD_SET:
            return { ...state };

        case COMMUNICATION_UPLOAD_SET_SUCCESS:
            return {
                ...state,
                file: { ...state.file, ...action.payload }
            };

        case COMMUNICATION_UPLOAD_SET_ERROR:
            return {
                ...state,
                file: { ...state.file, ...action.payload }
            };

        case COMMUNICATION_UPLOAD_RESET:
            return {
                ...state,
                file: []
            };

        default:
            return { ...state };
    }
};